// extracted by mini-css-extract-plugin
export default {"root":"UpdateMonthlyToAnnuallySection_root__AOWxj","paymentContainer":"UpdateMonthlyToAnnuallySection_paymentContainer__mNs-o"};